module.exports = __webpack_public_path__ + "assets/img/logo01.75f34a34.png";